import WhiteText from "components/WhiteText";
import React from "react";
import { View } from "react-native";
import {
  ArrowContainer,
  PopoverProps,
  Popover as RTP,
} from "react-tiny-popover";

const Popover = (
  props: Omit<PopoverProps, "content"> & { popoverText: string }
) => {
  const { popoverText } = props;
  return (
    <RTP
      {...props}
      containerStyle={{ zIndex: "200" }} // Must be greater than the zIndex of BottomSheet.tsx, otherwise the popover will be hidden
      content={({ position, childRect, popoverRect }) => (
        <ArrowContainer
          position={position}
          childRect={childRect}
          popoverRect={popoverRect}
          arrowSize={10}
          arrowColor="rgb(31, 38, 45)"
        >
          <View
            style={{
              backgroundColor: "rgb(31, 38, 45)",
              borderRadius: 8,
              padding: 15,
            }}
          >
            <WhiteText>{popoverText}</WhiteText>
          </View>
        </ArrowContainer>
      )}
    ></RTP>
  );
};

export default Popover;
